"use strict";
exports.__esModule = true;
exports.simpleCardContainer = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var fields_1 = require("../../../fields");
var simpleCardContainer = function (data, logger) {
    var _a, _b, _c, _d;
    return utils_1.compact({
        type: types_1.FooterCardType.SIMPLE,
        image: logger.required(fields_1.toImage((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.image, logger)),
        title: logger.required(fields_1.toText((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.title)),
        ctaLabel: logger.required(fields_1.toText((_c = data === null || data === void 0 ? void 0 : data.primary) === null || _c === void 0 ? void 0 : _c.ctaLabel)),
        ctaLink: logger.required(fields_1.toLink((_d = data === null || data === void 0 ? void 0 : data.primary) === null || _d === void 0 ? void 0 : _d.ctaLink, logger))
    });
};
exports.simpleCardContainer = simpleCardContainer;
//# sourceMappingURL=footer-simple-card.js.map